import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsPerformanceWorkTypeRoute: InvariantJiraRoute = {
	name: 'global-settings-performance-work-type',
	path: '/jira/settings/system/performance/metrics/worktype',
};
